import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { APP_ROUTES } from '../shared/config/routes-config';
import { RouteConfig } from '../shared/interfaces/routes-config.interface';
import ReservationsListContainer from './containers/reservation-list/reservation-list.container';
import { ReservationsEditContainer } from './containers/reservation-edit/reservation-edit.container';

/**
 * function ReservationModule components
 */
export const ReservationModule: React.FC = () => {
  return (
    <>
      <Route exact path={APP_ROUTES.RESERVATION_MODULE.FULL_PATH}>
        <Redirect to={(APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH} />
      </Route>
      <Route
        path={(APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
        component={ReservationsListContainer}
      />
      <Route
        path={(APP_ROUTES.RESERVATION_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH}
        component={ReservationsEditContainer}
      />
    </>
  );
};
